import React from 'react';
import PropTypes from 'prop-types';

import { getAppProps } from '@pages/_app';
import { buildDataUrl, buildFilterQuery } from '@helper/api';
import TemplateDefault from '../../templates/default/default';
import Stage from '../../organisms/stage/stage';
import MainStage from '../../organisms/main-stage/mainStage';
import CampaignStage from '../../organisms/campaign-stage/campaignStage';

import Filter from '../../molecules/filter/filter';
import FilterResults from '../../organisms/filter-results/filterResults';

const Time = ({ data: { hasCurtains, stageType }, page = 1 }) => {
  const currentPage = parseInt(page, 10);
  return (
    <TemplateDefault
      noLogo={currentPage === 1 && stageType === 'default'}
      invertedHeader={currentPage === 1 && stageType === 'campaign'}
      hasFilter
      hasCurtain={currentPage === 1 && hasCurtains}
    >
      {currentPage === 1 && stageType === 'default' && <MainStage />}
      {currentPage === 1 && stageType === 'campaign' && <CampaignStage />}
      {stageType !== 'campaign' && <Filter hasMargin={page > 1} />}
      {currentPage === 1 && stageType !== 'campaign' && <Stage />}

      <FilterResults pageType="index" />
    </TemplateDefault>
  );
};

Time.propTypes = {
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape({
    time: PropTypes.string.isRequired,
    hasCurtains: PropTypes.bool,
    stageType: PropTypes.string
  })
};

const getTimeProps = async ({ query, locale, uri }) => {
  const queryString = buildFilterQuery(query['filters[]'], query.page);

  const getPageProps = fetch(
    buildDataUrl(`${locale || 'de'}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/${uri}`, queryString)
  )
    .then(res => res.json())
    .catch(err => console.error(err));

  const [appProps, data] = await Promise.allSettled([getAppProps({ locale }), getPageProps]).then(
    results => results.map(result => result.value)
  );

  return {
    PAGE_TYPE: 'TIME',
    ...appProps,
    ...data,
    page: query.page || '1'
  };
};

export default Time;
export { getTimeProps };
